
<template>
    <div id="loaderWrapper">
        <img class="animatedLogo" v-bind:src="logo"/>
        <h1 class="schemeTitle"> Loading managers.. </h1>
    </div>
</template>

<script>
import logo from '@/assets/svg/select_animated_new.svg';

export default {
    data () {
        return {
            logo,
        };
    },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    #loaderWrapper{
        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: #fefefe;
        .animatedLogo{
            position: absolute;
            left: 50%;
            margin-left:-400px;
            top:30%;
            width: 800px;
        }
        .schemeTitle{
            text-align: center;
            width: 100%;
            position: absolute;
            top: calc(30% + 180px);
            font-size: 28px;
        }
    }
</style>
